var chunkMapping = {
	"13": [
		7013
	],
	"41": [
		1041
	],
	"209": [
		1480,
		3153,
		3445,
		5687,
		6041,
		6228,
		6645,
		8900
	],
	"862": [
		6672,
		7700
	],
	"929": [
		1187
	]
};
var idToExternalAndNameMapping = {
	"1041": [
		"default",
		"./Text",
		247
	],
	"1187": [
		"default",
		"./xhr",
		247
	],
	"1480": [
		"default",
		"./renderCurrency",
		247
	],
	"3153": [
		"default",
		"./Skeleton",
		247
	],
	"3445": [
		"default",
		"./Select",
		247
	],
	"5687": [
		"default",
		"./Form",
		247
	],
	"6041": [
		"default",
		"./Loading",
		247
	],
	"6228": [
		"default",
		"./Input",
		247
	],
	"6645": [
		"default",
		"./InfoArea",
		247
	],
	"6672": [
		"default",
		"./Button",
		247
	],
	"7013": [
		"default",
		"./Link",
		247
	],
	"7700": [
		"default",
		"./Heading",
		247
	],
	"8900": [
		"default",
		"./Modal",
		247
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}